import apiClient from './axios';

export interface AlertLogResponse {
  id: number;
  deviceId: number;
  deviceName: string;
  regionName: string;
  alertType: string;
  grade: string;
  h2sValue: number;
  nh3Value: number;
  adminCount: number;
  successCount: number;
  failCount: number;
  message: string;
  status: string;
  errorMessage?: string;
  createdAt: string;
  sentAt?: string;
}

export interface AlertLogPageResponse {
  content: AlertLogResponse[];
  pageable: {
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    offset: number;
    pageSize: number;
    pageNumber: number;
    paged: boolean;
    unpaged: boolean;
  };
  last: boolean;
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}

export interface AlertLogStats {
  alarm: number;
  notification: number;
  processed: number;
}

// 알림 로그 목록 조회
export async function getAlertLogsApi(params: {
  page?: number;
  size?: number;
  regionName?: string;
  filterDate?: string;
  sortBy?: string;
  sortDir?: string;
}): Promise<AlertLogPageResponse> {
  const response = await apiClient.get('/api/alert-logs', { params });
  return response.data;
}

// 알림 로그 통계 조회
export async function getAlertStatsApi(filterDate?: string): Promise<AlertLogStats> {
  const params = filterDate ? { filterDate } : {};
  const response = await apiClient.get('/api/alert-logs/stats', { params });
  return response.data;
}

// 알림 로그 상세 조회
export async function getAlertLogApi(id: number): Promise<AlertLogResponse> {
  const response = await apiClient.get(`/api/alert-logs/${id}`);
  return response.data;
}

// 알림 처리 상태 업데이트
export async function updateAlertStatusApi(id: number, statusNote?: string): Promise<AlertLogResponse> {
  const params = statusNote ? { statusNote } : {};
  const response = await apiClient.put(`/api/alert-logs/${id}/status`, null, { params });
  return response.data;
}

// 알림 로그 엑셀 다운로드
export async function exportAlertLogsApi(params: {
  regionName?: string;
  filterDate?: string;
}): Promise<void> {
  const response = await apiClient.get('/api/alert-logs/export', {
    params,
    responseType: 'blob'
  });
  
  // 파일 다운로드 처리
  const blob = new Blob([response.data], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `alert-logs-${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}